import auth from '../api/auth';
// import router from '../router';


import {
  ACTIVATION_BEGIN,
  ACTIVATION_CLEAR,
  ACTIVATION_FAILURE,
  ACTIVATION_SUCCESS,
  REGISTRATION_BEGIN,
  REGISTRATION_CLEAR,
  REGISTRATION_FAILURE,
  REGISTRATION_SUCCESS,
} from './types';

export default {
  namespaced: true,
  state: {
    activationCompleted: false,
    activationError: false,
    activationLoading: false,
    registrationCompleted: false,
    registrationError: false,
    registrationLoading: false,
    registrationRaisonError: null,
    activationRaisonError: null,
  },
  actions: {
    createAccount({ commit }, { username, password1, password2, email }) {
      commit(REGISTRATION_BEGIN);
      return auth.createAccount(username, password1, password2, email)
        .then(() => commit(REGISTRATION_SUCCESS))
        // .catch(() => commit(REGISTRATION_FAILURE));
        // .then(() => router.push('/login'))
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // Test des erreurs retournées afin de l'afficher à l'utilisateur.
            // On alimente la raisonError de la LOGIN_FAILURE.
            var errorMessages = "";

            if (error.response.status == 500) {
              // error 500 : pb avec AWS SES
              console.log('error 500 : pb avec AWS SES')
              console.log(error.response.data)
              errorMessages = "Un problème inattendu s'est produit"
              commit(REGISTRATION_FAILURE, errorMessages);
            }
            else {
              console.log(error.response.data)

              for (var err in error.response.data) {
                console.log('error --> ' + error.response.data[err].join())
                errorMessages = errorMessages.concat(error.response.data[err].join())
              }
              console.log(errorMessages)
              console.log('errorMessages : ' + errorMessages)

              commit(REGISTRATION_FAILURE, errorMessages);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // console.log(error.config);
        });
    },
    activateAccount({ commit }, { key }) {
      commit(ACTIVATION_BEGIN);
      return auth.verifyAccountEmail(key)
        .then(() => commit(ACTIVATION_SUCCESS))
        // .catch(() => commit(ACTIVATION_FAILURE));
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // Test des erreurs retournées afin de l'afficher à l'utilisateur.
            // On alimente la raisonError de la LOGIN_FAILURE.
            var errorMessages = "";
            if (error.response.data) {
              console.log(error.response.data);

              for (var err in error.response.data) {
                console.log(error.response.data[err]);
                if (err instanceof Array) {
                  console.log('error --> ' + error.response.data[err].join());
                  errorMessages = errorMessages.concat(error.response.data[err].join());
                }
                else {
                  errorMessages = errorMessages.concat(error.response.data[err]);
                }
              }
              console.log(errorMessages);
              console.log('errorMessages : ' + errorMessages);

              commit(ACTIVATION_FAILURE, errorMessages);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // console.log(error.config);
        });
    },
    clearRegistrationStatus({ commit }) {
      commit(REGISTRATION_CLEAR);
    },
    clearActivationStatus({ commit }) {
      commit(ACTIVATION_CLEAR);
    },
  },
  mutations: {
    [ACTIVATION_BEGIN](state) {
      state.activationLoading = true;
    },
    [ACTIVATION_CLEAR](state) {
      state.activationCompleted = false;
      state.activationError = false;
      state.activationLoading = false;
      state.activationRaisonError = null
    },
    [ACTIVATION_FAILURE](state, raison) {
      state.activationError = true;
      state.activationLoading = false;
      state.activationRaisonError = raison;
    },
    [ACTIVATION_SUCCESS](state) {
      state.activationCompleted = true;
      state.activationError = false;
      state.activationLoading = false;
      state.activationRaisonError = null
    },
    [REGISTRATION_BEGIN](state) {
      state.registrationLoading = true;
      state.registrationCompleted = false;
      state.registrationError = false;
      state.registrationRaisonError = null;
    },
    [REGISTRATION_CLEAR](state) {
      state.registrationCompleted = false;
      state.registrationError = false;
      state.registrationLoading = false;
      state.registrationRaisonError = null;
    },
    [REGISTRATION_FAILURE](state, raison) {
      state.registrationCompleted = false
      state.registrationError = true;
      state.registrationLoading = false;
      state.registrationRaisonError = raison;
    },
    [REGISTRATION_SUCCESS](state) {
      state.registrationCompleted = true;
      state.registrationError = false;
      state.registrationLoading = false;
      state.registrationRaisonError = null;
    },
  },
};
